import React, { useState } from 'react';
import { Alert, Box, Button, Chip, Grid, Paper, Stack, TextField, Typography } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';

const endpointDefaults = {
  method: 'GET',
  url: '/api/health'
};

const ApiPortalPage = () => {
  const [endpoint, setEndpoint] = useState(endpointDefaults.url);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const runRequest = async () => {
    setLoading(true);
    setResult(null);
    try {
      const res = await fetch(endpoint, { method: 'GET' });
      const text = await res.text();
      setResult({ ok: true, status: res.status, text });
    } catch (err) {
      setResult({ ok: false, status: 0, text: String(err) });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Stack spacing={2.4}>
      <Paper sx={{ p: { xs: 3, md: 4 }, borderRadius: 4, background: 'linear-gradient(125deg,#022c43,#1d4ed8,#0ea5e9)', color: 'white' }}>
        <Typography variant="h3" sx={{ fontWeight: 800, mb: 1 }}>API Web 控制台</Typography>
        <Typography sx={{ fontSize: 16.5, opacity: 0.95 }}>
          用于接口联调、可用性验证和返回数据检查。默认接入生产同域 `/api/*` 路径。
        </Typography>
      </Paper>

      <Grid container spacing={2.2}>
        <Grid item xs={12} md={7}>
          <Paper sx={{ p: 3, borderRadius: 3, border: '1px solid #dbe7ff' }}>
            <Typography variant="h6" sx={{ fontWeight: 800, mb: 1.5 }}>在线调用</Typography>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.2}>
              <Chip label={endpointDefaults.method} color="primary" variant="outlined" sx={{ alignSelf: 'flex-start' }} />
              <TextField
                fullWidth
                label="接口地址"
                value={endpoint}
                onChange={(e) => setEndpoint(e.target.value)}
                size="small"
              />
              <Button variant="contained" onClick={runRequest} startIcon={<PlayArrowIcon />} disabled={loading}>
                {loading ? '请求中...' : '执行'}
              </Button>
            </Stack>
            <Box sx={{ mt: 2 }}>
              {result ? (
                <Alert severity={result.ok ? 'success' : 'error'}>
                  HTTP {result.status} · {result.ok ? '请求成功' : '请求失败'}
                </Alert>
              ) : (
                <Alert severity="info">输入接口后执行请求，结果会实时显示。</Alert>
              )}
            </Box>
            <Paper sx={{ mt: 2, p: 2, borderRadius: 2, background: '#0f172a', color: '#e2e8f0', minHeight: 180, overflow: 'auto' }}>
              <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{result ? result.text : '等待请求...'}</pre>
            </Paper>
          </Paper>
        </Grid>

        <Grid item xs={12} md={5}>
          <Paper sx={{ p: 3, borderRadius: 3, border: '1px solid #dbe7ff', height: '100%' }}>
            <Typography variant="h6" sx={{ fontWeight: 800, mb: 1.5 }}>常用接口</Typography>
            <Stack spacing={1.2}>
              <Button variant="text" sx={{ justifyContent: 'flex-start' }} onClick={() => setEndpoint('/api/health')}>
                /api/health
              </Button>
              <Button variant="text" sx={{ justifyContent: 'flex-start' }} onClick={() => setEndpoint('/api/location/ip')}>
                /api/location/ip
              </Button>
              <Button variant="text" sx={{ justifyContent: 'flex-start' }} onClick={() => setEndpoint('/api/auth/guest')}>
                /api/auth/guest
              </Button>
            </Stack>
            <Box sx={{ mt: 2.5, p: 2, borderRadius: 2, bgcolor: '#eff6ff' }}>
              <Stack direction="row" spacing={1} alignItems="center">
                <HealthAndSafetyIcon color="primary" />
                <Typography sx={{ fontWeight: 700 }}>健康检查建议</Typography>
              </Stack>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                发布后先验证 `/api/health` 返回 200，再执行核心业务接口 smoke 测试。
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Stack>
  );
};

export default ApiPortalPage;
